<!---------------------------------------------------------------->
<!-- Installation required                                      -->
<!---------------------------------------------------------------->
<!-- npm i tslib --location=global                              -->
<!-- npm i angular-split --location=global                      -->
<!---------------------------------------------------------------->

<style>
  .container {
    display: flex;
    flex-direction: column;
    height: calc(100vh - 120px);
    overflow: hidden;
  }

  .css-tabs {
    display: flex;
    flex-direction: column;
    height: 100%;
  }

  .tab-header {
    display: flex;
    padding: 8px 10px 0 10px;
    background-color: transparent !important;
    border-bottom: 1px solid #bdbdbd;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.08);
    z-index: 2;
  }

  .tab-header button {
    height: 40px;
    line-height: 40px;
    padding: 0 26px;
    margin-right: 12px;
    border-radius: 12px 12px 0 0;
    border: none;
    background-color: #2f557f;
    color: white;
    font-weight: 500;
    cursor: pointer;
  }

  .tab-header button:hover {
    background-color: #0b77a8;
  }

  .tab-header button.active {
    background-color: #0b77a8;
    font-weight: 600;
    position: relative;
    top: 1px;
  }

  .tab-body {
    flex: 1;
    background-color: white;
    border-radius: 0 0 14px 14px;
    overflow: hidden;
    padding: 0;
  }
</style>

<div style="border-radius: 14px" class="container">
  <div class="css-tabs">
    <!-- TAB HEADER -->
    <div class="tab-header">
      <button (click)="selectedTab = 0" [class.active]="selectedTab === 0">
        {{ "app.administration.logsTabTitle" | translate }}
      </button>
      <button (click)="selectedTab = 1" [class.active]="selectedTab === 1">
        {{ "app.administration.rightsTabTitle" | translate }}
      </button>
      <button (click)="selectedTab = 2" [class.active]="selectedTab === 2">
        {{ "app.administration.statisticsTabTitle" | translate }}
      </button>
      <button (click)="selectedTab = 4" [class.active]="selectedTab === 4">
        {{ "app.administration.supportDesk" | translate }}
      </button>
    </div>

    <!-- TAB BODY -->
    <div class="tab-body">
      <!-- ================= LOGS TAB ================= -->
      @if (selectedTab === 0) {
        <div class="logs-toolbar">
          <div class="logs-filters">
            <div class="search-box">
              <mat-icon class="search-icon">search</mat-icon>
              <input
                matInput
                type="text"
                [(ngModel)]="searchInput"
                (keyup)="applySearch($event.target.value)"
                placeholder="{{ 'app.administration.search' | translate }}"
              />
            </div>
            <div class="search-box">
              <mat-icon class="search-icon">event</mat-icon>
              <input
                matInput
                type="text"
                [(ngModel)]="weekCount"
                placeholder="{{ 'app.administration.weekCount' | translate }}"
              />
            </div>
          </div>
          <button style="margin-left: 20px" mat-raised-button color="primary" (click)="execute(false)">
            {{ "app.administration.execute" | translate }}
            <mat-icon>play_arrow</mat-icon>
          </button>
          <button mat-raised-button color="primary" (click)="execute(true)">
            {{ "app.administration.empty" | translate }}
            <mat-icon>delete</mat-icon>
          </button>
        </div>
        <div class="my-table mat-elevation-z8">
          <mat-table [dataSource]="dataSource" matSort>
            <ng-container matColumnDef="LOG_LogDatetime">
              <mat-header-cell style="max-width: 180px" *matHeaderCellDef mat-sort-header>
                {{ "app.administration.logDateTimeColumnHeader" | translate }}
              </mat-header-cell>
              <mat-cell style="max-width: 180px" *matCellDef="let row">
                {{ formatDate(row.LOG_LogDatetime) }}
              </mat-cell>
            </ng-container>
            <ng-container matColumnDef="LOG_LogSource">
              <mat-header-cell style="max-width: 150px" *matHeaderCellDef mat-sort-header>
                {{ "app.administration.logSourceColumnHeader" | translate }}
              </mat-header-cell>
              <mat-cell style="max-width: 150px" *matCellDef="let row">
                {{ row.LOG_LogSource }}
              </mat-cell>
            </ng-container>
            <ng-container matColumnDef="LOG_LogLevel">
              <mat-header-cell style="max-width: 150px" *matHeaderCellDef mat-sort-header>
                {{ "app.administration.logLevelColumnHeader" | translate }}
              </mat-header-cell>
              <mat-cell style="max-width: 150px" *matCellDef="let row">
                {{ row.LOG_LogLevel }}
              </mat-cell>
            </ng-container>
            <ng-container matColumnDef="LOG_LogMessage">
              <mat-header-cell *matHeaderCellDef mat-sort-header>
                {{ "app.administration.logMessageColumnHeader" | translate }}
              </mat-header-cell>
              <mat-cell class="clickable-cell" *matCellDef="let row">
                <div class="no-wrap" (click)="openDialog(row.LOG_LogMessage)">
                  {{ row.LOG_LogMessage }}
                </div>
              </mat-cell>
            </ng-container>
            <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>
            <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
          </mat-table>
        </div>
      }

      <!-- ================= RIGHTS TAB ================= -->
      @if (selectedTab === 1) {
        <app-rights></app-rights>
      }

      <!-- ================= STATISTICS TAB ================= -->
      @if (selectedTab === 2) {
        <app-statistics></app-statistics>
      }

      <!-- ================= SQL RUNNER TAB ================= -->
      @if (selectedTab === 4) {
        <app-sql-runner></app-sql-runner>
      }
    </div>
  </div>
</div>

@if (isProcessing) {
  <div class="processing-wrapper">
    <div class="processing-circle"></div>
    <div class="processing-text">
      {{ "app.misc.processing" | translate }}
    </div>
  </div>
}
